import type { DriveStep } from 'driver.js';

const at = (id: string) => `[data-tour="${id}"]`;

/** "Tour this page" for Brand Manager (/brands). Anchors live in BrandListPage.tsx. */
export function getBrandTourSteps(): DriveStep[] {
  return [
    {
      popover: {
        title: 'Your brand',
        description:
          'A brand is your colors, logo, and fonts. Your active brand is what the AI uses when it ' +
          'builds your site, so everything stays consistent.',
      },
    },
    {
      element: at('brand-new'),
      popover: {
        title: 'Create a brand',
        description: 'Start a new brand with a name and tagline, then customize its look.',
        side: 'bottom',
        align: 'end',
      },
    },
    {
      element: at('brand-list'),
      popover: {
        title: 'Manage your brands',
        description:
          'Your brands appear here. Click one to open the editor and set colors, upload your logo, ' +
          'and choose fonts. Use “Set Active” to pick which brand the AI builds with.',
        side: 'top',
        align: 'center',
      },
    },
  ];
}
